import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=2c8775c0&scoped=true&"
import script from "./Projects.vue?vue&type=script&lang=js&"
export * from "./Projects.vue?vue&type=script&lang=js&"
import style0 from "./Projects.vue?vue&type=style&index=0&id=2c8775c0&lang=scss&scoped=true&"
import style1 from "./Projects.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8775c0",
  null
  
)

export default component.exports